import { render, staticRenderFns } from "./DaftarCekGadai.vue?vue&type=template&id=4fcb3fb5&"
import script from "./DaftarCekGadai.vue?vue&type=script&lang=js&"
export * from "./DaftarCekGadai.vue?vue&type=script&lang=js&"
import style0 from "./DaftarCekGadai.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports